<div class="alert alert-danger">
  <div class="mb-4">
    <b>WARNING</b>: You are about to delete the entity below.
    Please review its details carefully, since this operation cannot be undone, once you click the
    <i>Confirm Deletion</i> button.
  </div>
  <templating-preview [hideActions]="true"></templating-preview>
</div>
<actions-container [ngClass]="'mb-4'">
  <back-button></back-button>
  <button mat-raised-button color="warn" (click)="confirmDelete()">
    Confirm Deletion
  </button>
</actions-container>
